module.exports = __webpack_public_path__ + "img/mikadologo.37142954.png";